import { Observable } from 'rxjs';
import { AbstractControl, Validator, FormControl } from '@angular/forms';
import { AppService } from '../app.service';
import { ProjectItem } from "./projectItem";
import { AuthService } from '../core/auth.service';
import { AppInjector } from "../index";
// import {HTTP_PROVIDERS, Http, Headers} from "@angular/http";

interface IProjectValidator {
    [key: string]: boolean;
}

function checkProject(control: AbstractControl, existingItem: string, keyCode:boolean= false): Observable<IProjectValidator> {

    let appService: AppService = AppInjector.get(AppService);//.get(AuthService).get(Http);
    let reason = 'projectTaken';

    // console.log('checking against: ' + existingItem + ' with KeyCode: ' + keyCode.toString())

    // Return an observable with null if the
    // project name is not taken
    // an objet with the rejetion reason if it does
    return new Observable((obs: any) => {

        if (control.value.trim() == existingItem) {
            console.log('nothing to do, control.value ' + control.value.trim() + ' equals ' + existingItem);
            obs.next(null);
            obs.complete();
            return;
        }

        appService.rawSearch(true, control.value, keyCode)
            .subscribe(
            data => {
                console.log('back from rawSearch, data: ' + JSON.stringify(data));
                
                let result: ProjectItem[] = data;
                if (result.length > 0) {
                    obs.next({ [reason]: true });
                } else {
                    obs.next(null);
                }
                obs.complete();
            },
            error => {
                console.log('error...?' + error);
                obs.next({ [reason]: true });
                obs.complete();
            }
            );
    });
}

export class ProjectValidator {

    constructor() { }

    static checkProjectName(keyCode:boolean = false, itemId: string = '') {
        return (c: AbstractControl) => {
            return checkProject(c, itemId, keyCode);// && Observable.of(itemId != '');
        }
    }


}